<template>

  <form @submit.prevent="saveFile">

    <div class="field">
      <div class="control">
        <v-btn block color="blue-grey" dark @click="$refs.inputUpload.click()">Browse <v-icon right dark>cloud_upload</v-icon></v-btn>
        <input v-show="false" ref="inputUpload" type="file" id="files" @change="onFileSelected">
      </div>

    </div>
    <br>
    <div class="progress">
      <v-progress-circular
          :rotate="-90"
          :size="100"
          :width="15"
          :value="progress"
          color="primary"
        >
          {{ progress }}
      </v-progress-circular>
    </div>

    <!-- <div class="field">
      <div class="control">
        <input id="name" class="input" type="text" placeholder="Name" v-model="name" required>
      </div>
    </div> -->

    <!-- <button @click="logProp">logProp()</button> -->


    <div class="field">
      <div class="control">
        <v-btn block color="secondary" :disabled="disabled" id="submit-btn" type="submit">Submit</v-btn>
      </div>
    </div>

  </form>

</template>

<script>
  import firebase from 'firebase'
  import db from '../main.js'

  export default {
    name: 'upload',
    props: ['folder'],
    data: function() {
      return {
        selectedFile: null,
        name: null,
        type: null,
        category: null,
        bucketRef: null,
        creatorId: null,
        progress: 0,
        disabled: true
      }
    },
    mounted() {
      document.getElementById("submitBtn").disabled = true;
      var inputs = document.querySelectorAll( '.inputfile' );

      // Array.prototype.forEach.call( inputs, function( input ) {
      //   var label = input.nextElementSibling,
      //               labelVal = label.innerHTML;
      //
      //   input.addEventListener( 'change', function( e ) {
      //     var fileName = '';
      //
      //     fileName = e.target.value.split( '\\' ).pop();
      //
      //     if ( fileName ) {
      //       label.querySelector( 'span' ).innerHTML = fileName;
      //     } else {
      //       label.innerHTML = labelVal;
      //     }
      //   });
      // });
    },
    methods: {
      //Uploading to storage
      onFileSelected(event) {
        var self = this;

        var storage = firebase.storage();
        //Get file
        var file = event.target.files[0];
        console.log(file);
        self.name = file.name;

        //Create storage ref
        var storageRef = firebase.storage().ref('files/' + this.folder.company + '/' + file.name);

        var uploadTask = storageRef.put(file);

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function(snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            self.progress = parseInt((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            // document.getElementById('progress-bar').setAttribute("aria-valuenow", progress);
            // document.getElementById('progress-bar').setAttribute("style", "width: " + progress + "%;");
            // document.getElementById('progress-bar').innerHTML = progress.toFixed(0) + "%";
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused');
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running');
                break;
            }
          }, function(error) {

          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break;

            case 'storage/canceled':
              // User canceled the upload
              break;

            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
        }, function() {
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            self.bucketRef = downloadURL;
            console.log('File available at', downloadURL);
            self.disabled = false;
            document.body.click();
          });
        });

      },
      //Storing reference to the file in Firestore
      saveFile() {
        console.log("SAVING");
        var self = this;
        db.collection('files').add({
          name: this.name,
          folder: this.folder.name,
          company: this.folder.company,
          created: new Date().toDateString(),
          bucketRef: this.bucketRef,
          slug: this.generateUUID(),
          user: firebase.auth().currentUser.uid
        })
          .then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
          })
          .catch(function (error) {
            console.error('Error adding document: ', error)
          })
      },
      logProp() {
        console.log(this.folder);
        console.log(this.folder.uid);
        console.log(this.folder.company);
      },
      //Just an example of creating a unique UUID
      generateUUID() {
        let d = new Date().getTime()
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          let r = (d + Math.random() * 16) % 16 | 0
          d = Math.floor(d / 16)
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
        return uuid
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .upload {
    margin-top: 40px;
  }
  .upload-card {
    padding: 40px;
    margin: 0 auto;
    text-align: left;
  }
  .card-body {
    padding: 1.25rem;
    border: 1.25rem solid #fff;
    border-radius: .5rem;
  }
  .inputfile {

  }
  .btn-file {
    position: relative;
    overflow: hidden;
    background-color: #CF0001;
    color: #fff;
    width: 100%;
    transition: background-color 0.3s;
  }
  .btn-file:hover {
    position: relative;
    overflow: hidden;
    background-color: #490000;
    color: #fff;
    width: 100%;
  }
  .btn-file input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;
    background-color: white;
    cursor: inherit;
    display: block;
  }
  #name {
    width: 100%;
  }
  #options {
    padding: 10px;
    margin: 20px;
    margin: 20px auto;
    color: #000;
  }
  #c-type, #c-outcomes, #c-use {
    margin: 10px;
  }
  #files {
    margin: 0 auto;
    display: block;
    background-color: rgba(255,255,255,0.85);
    color: #000;
    height: 65px;
    font-weight: bold;
  }
  #name, #files {
    padding: 20px;
  }
  .progress {
    margin: 0 auto;
    margin-bottom: 20px;
  }
  #submitBtn {
    width: 100%;
    background-color: #000;
    color: #fff;
  }
</style>
